package theme

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.staticCompositionLocalOf

data class ReaptiveColors(
    val primary: String,
    val onPrimary: String,
    val background: String,
    val onBackground: String,
    val surface: String,
    val onSurface: String,
    val onSurfaceVariant: String,
    val surfaceContainer: String,
    val outlineVariant: String,
    val shadowSm: String,
    val shadowMd: String,
    val scrollShadow: String,
    val scrim: String
)

val LocalReaptiveColors = staticCompositionLocalOf {
    ReaptiveColors(
        primary = LightColors.primary,
        onPrimary = LightColors.onPrimary,
        background = LightColors.background,
        onBackground = LightColors.onBackground,
        surface = LightColors.surface,
        onSurface = LightColors.onSurface,
        onSurfaceVariant = LightColors.onSurfaceVariant,
        surfaceContainer = LightColors.surfaceContainer,
        outlineVariant = LightColors.outlineVariant,
        shadowSm = LightColors.shadowSm,
        shadowMd = LightColors.shadowMd,
        scrollShadow = LightColors.scrollShadow,
        scrim = LightColors.scrim
    )
}

@Composable
fun ReaptiveTheme(isDark: Boolean, content: @Composable () -> Unit) {
    val colors = if (isDark) {
        ReaptiveColors(
            primary = DarkColors.primary,
            onPrimary = DarkColors.onPrimary,
            background = DarkColors.background,
            onBackground = DarkColors.onBackground,
            surface = DarkColors.surface,
            onSurface = DarkColors.onSurface,
            onSurfaceVariant = DarkColors.onSurfaceVariant,
            surfaceContainer = DarkColors.surfaceContainer,
            outlineVariant = DarkColors.outlineVariant,
            shadowSm = DarkColors.shadowSm,
            shadowMd = DarkColors.shadowMd,
            scrollShadow = DarkColors.scrollShadow,
            scrim = DarkColors.scrim
        )
    } else {
        ReaptiveColors(
            primary = LightColors.primary,
            onPrimary = LightColors.onPrimary,
            background = LightColors.background,
            onBackground = LightColors.onBackground,
            surface = LightColors.surface,
            onSurface = LightColors.onSurface,
            onSurfaceVariant = LightColors.onSurfaceVariant,
            surfaceContainer = LightColors.surfaceContainer,
            outlineVariant = LightColors.outlineVariant,
            shadowSm = LightColors.shadowSm,
            shadowMd = LightColors.shadowMd,
            scrollShadow = LightColors.scrollShadow,
            scrim = LightColors.scrim
        )
    }

    CompositionLocalProvider(LocalReaptiveColors provides colors) {
        content()
    }
}

object ReaptiveTheme {
    val colors: ReaptiveColors
        @Composable get() = LocalReaptiveColors.current
}
